<template>
  <div class="container">
    <titular />

    <table class="table">
      <thead>
        <tr>
          <th scope="col">Ruta</th>
          <th scope="col">Rols</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(route, index) in routes" :key="index">
          <th scope="row">
            <router-link :to="`/${route.path}`" target="_blank">/{{ route.path }}</router-link>
          </th>
          <td>{{ route.rols }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>
        
<script>
export default {
  name: "",
  data() {
    return {
      routes: [],
    };
  },
  methods: {
    getData() {
      this.$http.get("api/routes").then((response) => (this.routes = response.data));
    },
  },
  mounted() {
    this.getData();
  },
};
</script>
    
<style lang="scss" scoped></style>